import { render, staticRenderFns } from "./hzshow.vue?vue&type=template&id=c9c309e0&scoped=true"
import script from "./hzshow.vue?vue&type=script&lang=js"
export * from "./hzshow.vue?vue&type=script&lang=js"
import style0 from "./hzshow.vue?vue&type=style&index=0&id=c9c309e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c309e0",
  null
  
)

export default component.exports